import { memo, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from "./Footer";
import { StyleProcessor } from "./helpers/StyleProcessor";


const LoginForm = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loginResponseData, setLoginResponseData] = useState({});
    const navigate = useNavigate();
    const inputEmailField = useRef(null);
    const inputPasswordField = useRef(null);
    const [isSubmit, setIsSubmit] = useState(false);
    let [isInputEmailFocused, setInputEmailFocused] = useState(false);
    let [isInputPasswordFocused, setInputPasswordFocused] = useState(false);

    useEffect(
        () => {
        }, []
    );

    const toggleShowPassword = (e) => {
        inputPasswordField.current.getAttribute("type") === "password"
            ? inputPasswordField.current.setAttribute("type", "text")
            : inputPasswordField.current.setAttribute("type", "password")
        new StyleProcessor(e.target).toggleClass('fa-eye').toggleClass('fa-eye-slash')
    }

    const showLoadingState = (e) => {
        setIsSubmit(true);
    };

    const handleLogin = (event) => {
        const loginURL = `${process.env.REACT_APP_BASE_URL}/token/`;
        // const loginURL = "https://blessedmayowa.pythonanywhere.com/login/";
        const headers = {
            'Accept': '*/*',
            // 'Origin': '*',
        };
        const fetchInit = {
            method: 'POST',
            headers: headers,
            mode: 'cors',
            body: new FormData(event.target),
            cache: 'default',
        };
        event.preventDefault();

        fetch(loginURL, fetchInit)
            .then(response => {
                if (response.status !== 200) {
                    throw response;
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                // Store the token from the login response
                localStorage.setItem('nine_login', data['access']);
                localStorage.setItem('nine_refresh', data['refresh']);

                // reset the login form
                event.target.reset();
                setEmail('');
                setPassword('');
                setLoginResponseData({
                    message: "Login successful",
                    successful: true,
                    error: false
                });
                setTimeout(() => {
                    navigate('/');
                }, 800);
            })
            .catch((error) => {
                let error_message;
                if (error.status === 401) {
                    error_message = "Invalid login credentials"
                } else if (error.status === 400) {
                    error_message = "Login credentials are not valid"
                } else if (error.status === 500) {
                    error_message = "Check your internet connection"
                } else {
                    // There is no network connection or the Server is not up.
                    error_message = "Oops. Network Error"
                }
                setLoginResponseData({
                    message: error_message,
                    successful: false,
                    error: true
                });
                // reset the isSubmit loader
                setIsSubmit(false);
            });
    }

    return (
        <>
            <form id="id-login-form" onSubmit={handleLogin}
                className="relative flex flex-column mg-x-auto pad-x1 pad-t2 pct:w-96 radius every:flex|flex-column|mg-y1|pad-y2|font-semibold lg:w-400|shadow:0-2px-12px-0-E8E8E8|pad-x4|pad-t4|pad-b4 dark:b-00030488|shadow-unset">
                {loginResponseData?.successful ? <div
                    className="relative mg-x-auto text-center pct:w-64 radius-sm bg-green-inverse color-green">{loginResponseData.message}</div> : null}
                {loginResponseData?.error ? <div
                    className="relative mg-x-auto text-center pct:w-64 radius-sm bg-red-inverse color-red">{loginResponseData.message}</div> : null}
                <label className="">
                    Email
                    <input
                        type="email"
                        name="email"
                        value={email || ""}
                        placeholder="Your email address"
                        onChange={(e) => setEmail(e.target.value)}
                        onFocus={(e) => setInputEmailFocused(true)}
                        onBlur={(e) => setInputEmailFocused(false)}
                        ref={inputEmailField}
                        className="pct:w-100 h-8 lh-8 pad-x2 mg-y1 outline:1px_solid_transparent border:1px_solid_lightgray outline-offset-2 focus:outline:2px_solid_gray transition:outline_80ms_ease radius-sm font-12 placeholder:font-regular dark:bg-222425|border:1px_solid_000304|color-whitesmoke dark:focus:outline:3px_solid_444445|bg-333435"
                    />
                </label>
                <label className="">
                    Password
                    <div className={"relative flex flex-row align-items-center"}>
                        <input
                            type="password"
                            name="password"
                            value={password || ""}
                            placeholder="Your password"
                            onChange={(e) => setPassword(e.target.value)}
                            onFocus={(e) => setInputPasswordFocused(true)}
                            onBlur={(e) => setInputPasswordFocused(false)}
                            ref={inputPasswordField}
                            className="pct:w-100 h-8 lh-8 pad-x2 mg-y1 outline:1px_solid_transparent border:1px_solid_lightgray outline-offset-2 focus:outline:2px_solid_gray transition:outline_80ms_ease radius-sm font-12 placeholder:font-regular dark:bg-222425|border:1px_solid_000304|color-whitesmoke dark:focus:outline:3px_solid_444445"
                        />
                        {password.length > 0 ? <span className={"fa fa-eye abs px:right-4 square-7 lh-7 radius text-center cursor-pointer dark:bg-11131488"} onClick={toggleShowPassword}></span> : null}
                    </div>
                    <Link to={"/forgot-password"} className={"pad-x1 color-red"}>Forgot password?</Link>
                </label>
                <div>
                    <button
                        type="submit"
                        className="d-block pct:w-64 h-7 lh-7 mg-x-auto text-center radius bg-green border-0 color-FFF font-14 font-medium cursor-pointer disabled:bg-green-inverse|cursor-not-allowed dark:disabled:color-BBB8"
                        disabled={!(email && password.length >= 8)}
                        onClick={e => showLoadingState(e)}
                    >
                        {isSubmit ? <span className='fa fa-spinner fa-spin'></span> : "Submit"}
                    </button>
                </div>
            </form>
            <div className={"d-block pct:w-72 mg-x-auto mg-y4 border:0px_solid_BBB em:border-t-0.05 lg:w-320|mg-y8|border-DDD dark:border:0px_solid_444445 dark:em:border-t-0.05"}></div>
            <div
                className={"pct:w-96 mg-x-auto text-center lg:w-400"}>
                Don't have an account? <Link to={"/signup"} className={"font-bold pad-y2 pad-x1 color-initial dark:color-whitesmoke"}>Signup</Link>
            </div>
        </>
    )
}


const Login = () => {
    return (
        <div className="relative flex flex-column pct:h-100 pad-y2 lg:justify-center|align-items-center|pad-y4 dark:bg-111314|color-whitesmoke">
            {/*<div id="stt" className="align-self-center d-block pct:w-96 sticky top-2 lg:pct:w-56 mg-x-auto pad-2 pad-x8 radius bg-navajowhite z-10">*/}
            {/*    <h3 className="text-center">To fill the Login form;</h3>*/}
            {/*    <div className=""><span className="fa fa-caret-right font-8 pad-x1"></span> Click on any of the input fields;</div>*/}
            {/*    /!*and the input field you've selected will be populated with what you say;*!/*/}
            {/*    <div className=""><span className="fa fa-caret-right font-8 pad-x1"></span> Speak the value you want to populate the field with;</div>*/}
            {/*    <div><span className="fa fa-caret-right font-8 pad-x1"></span> Watch the field get populated.</div>*/}

            {/*    <br />*/}
            {/*    <div className="font-italic text-center">You can re-listen to this by clicking the play button at the top right corner of this banner.</div>*/}
            {/*    <span*/}
            {/*        onClick={true}*/}
            {/*        className="fa fa-play font-10 color-black abs top-8 right-2 square-4 lh-4 text-center radius-circle bg-4446 cursor-pointer"></span>*/}
            {/*</div>*/}
            {/*<Link to="/" className="fixed top-4 left-4 square-4 lh-4 lg:top-4|left-4|square-8|lh-8 color-initial text-center font-14 radius-circle z-10"><span className="fa fa-arrow-left"></span></Link>*/}
            <Link to={"/"} className="relative text-left font-28 font-black lh-normal mg-b2 pad-l2 decoration-none color-initial lg:mg-b6|text-center dark:color-whitesmoke">
                Nine
                {/*<div className={"text-left mg-b4 lh-100 font-14 font-regular"}>All Naija Apps in one place</div>*/}
            </Link>
            <div className="text-left mg-b4 pad-l2 font-16 font-semibold lh-normal lg:mg-b0|pad-x-auto|font-15|font-medium">Login to your Account</div>
            {/*<div className="text-center font-28 font-medium lh-normal">Nine</div>*/}
            <LoginForm />
            <Footer miniDetails={true} />
        </div>
    );
};

export default memo(Login);